import {AssetsRequestParams} from "../../../infrastructure/models/params/assets-request-params";

export class HamburgerImageRequestParams extends AssetsRequestParams {
  constructor(width: Number, height: Number, color: String) {
    super(width, height);

    this.resourceName = this.resourceName + '/WebMenu/hamburgericon';
    this.color = color;
    this.c = null;
  }
}